import React from 'react'
import temp1 from "../Images/ac1.jpg"
import db1 from "../Images/db1.jpg"
import db2 from "../Images/db2.jpg"
import db3 from "../Images/db3.jpg"
import db4 from "../Images/db4.jpg"
import z1 from "../Images/z1.jpg"
import z2 from "../Images/z2.jpg"
import z3 from "../Images/z3.png"
import z4 from "../Images/z4.png"
import z5 from "../Images/z5.png"
import z6 from "../Images/z6.png"
import z7 from "../Images/z7.jpg"
import z8 from "../Images/z8.jpg"


export default function OtherServices() {
  return (
    <div className=' p-2 my-4'>
      <div className='bg-white
    p-2 row  '>

        {/* <h3 className='text-white font-monospace bg-dark p-2'>Digital Banking</h3> */}
        <div className='col border  border-success p-2'>
          <center><img
            src={z5}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
            <span></span>
          </center>
        </div>
        <div className='col border  border-success p-2'>
          <center><img
            src={z2}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
          </center>
        </div>
        <div className='col border  border-success p-2'>
          <center><img
            src={z3}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
          </center>
        </div>
        </div>


        <div className='bg-white
         p-2 row  '>

        {/* <h3 className='text-white font-monospace bg-dark p-2'>Digital Banking</h3> */}
        <div className='col border  border-success p-2'>
          <center><img
            src={z6}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
            <span></span>
          </center>
        </div>
        <div className='col border  border-success p-2'>
          <center><img
            src={z7}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
          </center>
        </div>
        <div className='col border  border-success p-2'>
          <center><img
            src={z8}
            class="img-fluid   "
            alt="Townhouses and Skyscrapers"
          />
          </center>
        </div>
      


    </div>
    </div>
  )
}
